import { defineStore } from 'pinia';
import type { ListingProduct } from '~/models/ListingProduct.api.model';

type State = {
  plansFastpris: ListingProduct[];
  plansSaldo: ListingProduct[];
  plansStartpaket: ListingProduct[];
  selectedPlan: ListingProduct | null;
};

export const usePrePaidStore = defineStore('prePaidStore', {
  state: (): State => ({
    plansFastpris: [],
    plansSaldo: [],
    plansStartpaket: [],
    selectedPlan: null,
  }),
  actions: {
    setPrePaidPlans(data: ListingProduct[], planGroupId: number): void {
      if (planGroupId === 3) this.plansFastpris = data;
      if (planGroupId === 4) this.plansSaldo = data;
      if (planGroupId === 5) this.plansStartpaket = data;
    },
    setPlanId(planId: string): void {
      const allPlans = [
        ...this.plansFastpris,
        ...this.plansSaldo,
        ...this.plansStartpaket,
      ];
      const selectedPlan = allPlans.find(
        (plan) => plan.ProductId === Number(planId),
      );
      if (selectedPlan) {
        this.selectedPlan = selectedPlan;
      }
    },
  },
  getters: {
    trackingData(): ProductPageTrackingData {
      const trackingData: ProductPageTrackingData = {
        productPriceId: 0,
        downPayTime: '0',
        ecommerce: {
          items: [
            {
              item_brand: 'Halebop',
              item_category: 'Kontantkort',
              item_id:
                this.selectedPlan?.Variants?.at(0)?.Prices.BundlePrices?.at(0)
                  ?.Plan?.PlanId,
              item_name: this.selectedPlan?.ProductName,
              item_variant: '0 månader',
              price:
                this.selectedPlan?.Variants?.at(0)?.Prices.BundlePrices?.at(0)
                  ?.Plan?.OneTimeFee,
              quantity: 1,
            },
          ],
        },
      };
      return trackingData;
    },
  },
});
